const PropagacionScreen = () => {
  return (
    <div>PropagacionScreen</div>
  )
}
export default PropagacionScreen